<template>
  <div>
    <v-btn
      dark
      small
      color="edit"
      class="profile-btn mr-3"
      @click="dialog = true"
    >
      {{ $t("horses:button.importHorsesCsv") }}
    </v-btn>
    <AppDialogContent
      v-model="dialog"
      :error="error"
      :persistent="loading"
      :disabled-submit="!Boolean(file)"
      :loading="loading"
      @submit-form="importFile"
    >
      <template #header> </template>

      <v-file-input v-model="file" :disabled="loading" accept=".csv" outlined />
    </AppDialogContent>
  </div>
</template>
<script>
import gql from "fraql";
import AppDialogContent from "@elements/AppDialogContent.vue";

export default {
  name: "HorseImportCSV",
  components: {
    AppDialogContent
  },
  data() {
    return {
      dialog: false,
      loading: false,
      file: null,
      error: null
    };
  },
  methods: {
    async importFile() {
      if (!this.file) return;
      this.loading = true;

      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation horseImportFromCsv($importFile: Upload!) {
              horseImportFromCsv(input: { importFile: $importFile }) {
                success
              }
            }
          `,
          variables: {
            importFile: this.file
          }
        });
        this.dialog = false;
        this.file = null;
        this.$root.$snackbar.open("success", {});
      } catch (error) {
        this.error = { type: "graphql", err: error };
        this.$sentryThrowError.throwError(error, {
          level: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
